import firebase from "firebase/app";
import "firebase/auth";

import { AppThunk } from "services/redux/rootReducer";

const logoutUser = (): AppThunk<Promise<void>> => () => {
    const logoutPromise = firebase.auth().signOut();

    return logoutPromise;
};

export default logoutUser;
